import spartacusOnboardingAPI from '@api/jooicez-backend/spartacus/onboarding';
import orange from '@assets/onboarding-spartacus-v2/clinic-orange.png';
import Iconify from '@components/iconify';
import { Box, Button, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material';
import icons from '@utils/icons';
import { useState } from 'react';
import { useApp } from 'src/contexts/ApplicationContext';
import { useResponsive } from 'src/hooks/use-responsive';

import { StepProps } from './steps';

export default function BusinessNumberStep({ onNext }: StepProps) {
  const { currentOrganization } = useApp();
  const [businessNumber, setBusinessNumber] = useState('');
  const [consentChecked, setConsentChecked] = useState(false);
  const isMobile = useResponsive('down', 'sm');
  const digitCount = businessNumber.replace(/\D/g, '').length;
  const hasMinimumDigits = digitCount >= 7;

  const handleContinue = () => {
    spartacusOnboardingAPI.saveAccountInfo({
      phoneNumber: businessNumber,
      marketingConsent: consentChecked,
      businessName: currentOrganization.name,
    });
    onNext();
  };

  return (
    <Box
      sx={{
        width: '100%',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        pt: { xs: 4, sm: 0 },
        gap: { xs: 3, sm: 4 },
        position: 'relative',
      }}
    >
      <img
        src={orange}
        alt="Clinic"
        style={{
          width: isMobile ? '120px' : '200px',
          position: 'fixed',
          bottom: 20,
          ...(isMobile ? { right: 0 } : { left: 20 }),
        }}
      />
      {/* Flex spacers bias the content to the upper third on desktop (no fixed paddings) */}
      <Box sx={{ display: { xs: 'none', sm: 'block' }, flexGrow: 2 }} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: 2,
          width: '100%',
          maxWidth: 420,
        }}
      >
        <Typography variant={isMobile ? 'h2' : 'h1'} color="text.primary">
          Which{' '}
          <Box component="span" sx={{ color: 'secondary.darker' }}>
            number
          </Box>{' '}
          do you use to text your patient?
        </Typography>
        <Typography variant="body1">Patients should feel they can easily contact you for support.</Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%', maxWidth: 400 }}>
        <TextField
          sx={{ width: '100%', maxWidth: 400 }}
          label="Business Number"
          type="number"
          value={businessNumber}
          onChange={(e) => setBusinessNumber(e.target.value)}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={consentChecked}
              onChange={(e) => setConsentChecked(e.target.checked)}
              color="secondary"
            />
          }
          label={
            <Typography variant="body2" color="text.secondary">
              By subscribing, you agree to receive marketing emails, offers, and updates from us.
            </Typography>
          }
        />
        <Button
          variant="contained"
          color="primary"
          size="large"
          disabled={!hasMinimumDigits}
          onClick={handleContinue}
          endIcon={<Iconify icon={icons.arrows.right} />}
          fullWidth
        >
          Continue
        </Button>
      </Box>
      <Box sx={{ display: { xs: 'none', sm: 'block' }, flexGrow: 3 }} />
    </Box>
  );
}
